module.exports = __webpack_public_path__ + "img/marianne-title.3bb24a06.png";